"use strict";

var X = Object.create;
var l = Object.defineProperty,
    Y = Object.defineProperties,
    z = Object.getOwnPropertyDescriptor,
    G = Object.getOwnPropertyDescriptors,
    J = Object.getOwnPropertyNames,
    p = Object.getOwnPropertySymbols,
    Z = Object.getPrototypeOf,
    x = Object.prototype.hasOwnProperty,
    w = Object.prototype.propertyIsEnumerable;

var y = (t, e, n) => e in t ? l(t, e, {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: n
}) : t[e] = n,
    i = (t, e) => {
  for (var n in e || (e = {})) x.call(e, n) && y(t, n, e[n]);

  if (p) for (var n of p(e)) w.call(e, n) && y(t, n, e[n]);
  return t;
},
    m = (t, e) => Y(t, G(e));

var h = (t, e) => {
  var n = {};

  for (var r in t) x.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);

  if (t != null && p) for (var r of p(t)) e.indexOf(r) < 0 && w.call(t, r) && (n[r] = t[r]);
  return n;
};

var ee = (t, e) => {
  for (var n in e) l(t, n, {
    get: e[n],
    enumerable: !0
  });
},
    W = (t, e, n, r) => {
  if (e && typeof e == "object" || typeof e == "function") for (let s of J(e)) !x.call(t, s) && s !== n && l(t, s, {
    get: () => e[s],
    enumerable: !(r = z(e, s)) || r.enumerable
  });
  return t;
};

var T = (t, e, n) => (n = t != null ? X(Z(t)) : {}, W(e || !t || !t.__esModule ? l(n, "default", {
  value: t,
  enumerable: !0
}) : n, t)),
    te = t => W(l({}, "__esModule", {
  value: !0
}), t);

var ge = {};
ee(ge, {
  FailedFetchError: () => f,
  PAGE_UUID_KEY: () => j,
  QUEUE_COMPLETED: () => Q,
  QUEUE_CONTINUED: () => F,
  SEND_COMPLETED: () => K,
  SEND_STARTED: () => I,
  VISITOR_TOKEN_KEY: () => M,
  WT: () => v,
  WTProvider: () => ae,
  createProvider: () => b,
  default: () => de,
  useTrack: () => ce,
  useWT: () => ue,
  withContext: () => B
});
module.exports = te(ge);
var a = T(require("react"));

var b = function (t) {
  let {
    validateEvent: e
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let n = a.default.createContext({
    params: {
      current: {}
    },
    track: () => {
      throw new Error("No WTProvider found");
    }
  });
  return {
    WTProvider: _ref => {
      let {
        params: o = {},
        children: c
      } = _ref;
      let g = (0, a.useRef)(o),
          {
        params: d
      } = (0, a.useContext)(n);
      g.current = i(i({}, d.current), o);
      let P = (0, a.useCallback)(H => {
        let k = i(i({}, g.current), H);
        (!e || e(k)) && t(k);
      }, []),
          $ = (0, a.useMemo)(() => ({
        track: P,
        params: g
      }), [P]);
      return a.default.createElement(n.Provider, {
        value: $
      }, c);
    },
    useWT: () => {
      let {
        track: o,
        params: c
      } = (0, a.useContext)(n);
      return {
        track: o,
        params: c.current
      };
    },
    useTrack: function () {
      let o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      let {
        track: c
      } = (0, a.useContext)(n),
          g = (0, a.useRef)(o);
      return (0, a.useEffect)(() => {
        g.current = o;
      }), (0, a.useCallback)(d => c(i(i({}, g.current), d)), [c]);
    }
  };
};

var E = T(require("js-cookie")),
    V = T(require("events"));

var D = t => Object.prototype.toString.call(t) === "[object Function]",
    O = function (t, e) {
  let {
    maxWait: n
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  let r,
      s,
      u,
      o = !1,
      c = () => {
    clearTimeout(r), clearTimeout(s), o = !1, u = void 0;
  },
      g = function () {
    return c(), t(...arguments);
  };

  return Object.assign(function () {
    for (var _len = arguments.length, d = new Array(_len), _key = 0; _key < _len; _key++) {
      d[_key] = arguments[_key];
    }

    clearTimeout(r), r = window.setTimeout(g, e, ...d), !o && n && (s = window.setTimeout(g, n, ...d), o = !0), u = () => t(...d);
  }, {
    clear: c,

    flush() {
      return u ? u() : null;
    }

  });
},
    R = t => t == null,
    _ = (t, e) => Object.keys(t).reduce((n, r) => e(t[r], r, t) ? n : m(i({}, n), {
  [r]: t[r]
}), {}),
    U = () => "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, t => {
  let e = Math.random() * 16 | 0;
  return (t === "x" ? e : e & 3 | 8).toString(16);
}),
    A = t => Object.keys(t).reduce((e, n) => (e[n.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase()] = t[n], e), {});

var ne = 500,
    re = 1500,
    N = 100,
    ie = 7300;

function S(t) {
  for (var _len2 = arguments.length, e = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    e[_key2 - 1] = arguments[_key2];
  }

  return D(t) ? t(...e) : t;
}

var I = "send:started",
    K = "send:completed",
    Q = "queue:completed",
    F = "queue:continued",
    M = "wt_visitor_token",
    j = "wt_page_uuid";

function L(t) {
  let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let n = E.default.get(t);
  return n || (n = U(), E.default.set(t, n, e)), n;
}

var q = t => {
  var e;
  return (e = new URLSearchParams(t).get("wvt")) != null ? e : void 0;
},
    se = function () {
  let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let e = arguments.length > 1 ? arguments[1] : undefined;
  return q(e) || L(M, t);
},
    oe = () => L(j),
    f = class extends Error {},
    v = class {
  constructor(e) {
    this.loading = !1;
    this.emitter = new V.default();
    this.wtConfig = {
      cookieOptions: {
        expires: ie
      }
    };
    this.paramDefaults = {};
    this.eventQueue = [];
    this.pageUuid = null;
    this.context = e, this.updateProcessEventsDebounced();
  }

  initialize(e) {
    this.config(e), this.wtConfig.cookieOptions && (this.getUUIDToken(), this.getVisitorToken());
  }

  getVisitorToken() {
    return this.wtConfig.visitorToken || se(this.wtConfig.cookieOptions, this.context.location && this.context.location.search);
  }

  getUUIDToken() {
    return this.pageUuid = oe(), this.pageUuid;
  }

  track(e) {
    var r;
    let n = typeof e == "string" ? {
      kind: e
    } : e;
    this.addToQueue(m(i({}, n), {
      kind: (r = n.kind) != null ? r : "event"
    }));
  }

  flush() {
    this.processEventsDebounced.flush();
  }

  clear() {
    this.paramDefaults = {};
  }

  set(e) {
    this.paramDefaults = i(i({}, this.paramDefaults), S(e, this.paramDefaults, this));
  }

  config(e) {
    this.wtConfig = i(i({}, this.wtConfig), S(e, this.wtConfig, this)), this.updateProcessEventsDebounced();
  }

  subscribe(e, n) {
    return this.emitter.on(e, n), () => {
      this.emitter.removeListener(e, n);
    };
  }

  addToQueue(e) {
    let c = e,
        {
      metadata: n
    } = c,
        r = h(c, ["metadata"]),
        g = this.paramDefaults,
        {
      metadata: d = {}
    } = g,
        s = h(d, []),
        u = h(g, ["metadata"]),
        o = i(i({}, s), n);
    this.eventQueue.push(_(A(m(i(m(i(i({}, u), r), {
      metadata: Object.keys(o).length > 0 ? o : void 0
    }), this.getEventEnvironmentArgs()), {
      ts: new Date().valueOf()
    })), R)), this.processEventsDebounced();
  }

  getRoot() {
    return this.wtConfig.trackerDomain ? this.wtConfig.trackerDomain : `//${this.context.location.hostname}`;
  }

  sendToServer(e, n, r) {
    var s;
    this.context.fetch(`${this.getRoot()}/wt/t`, i({
      method: "POST",
      credentials: "include",
      body: JSON.stringify(e),
      headers: i({
        "Content-Type": "text/plain"
      }, (s = this.wtConfig.fetchConfig) == null ? void 0 : s.headers),
      keepalive: !0
    }, this.wtConfig.fetchConfig)).then(u => {
      if (u.ok) n();else throw new f("Failed to send events, status code: " + u.status);
    }).catch(u => {
      var o, c;
      (c = (o = this.wtConfig).onError) == null || c.call(o, e, u), r();
    }), this.emitter.emit(I);
  }

  getRequestEnvironmentArgs() {
    return {
      visitor_token: this.wtConfig.visitorToken,
      dimensions: {
        width: this.context.innerWidth,
        height: this.context.innerHeight
      },
      agent: this.context.navigator.userAgent,
      rts: new Date().valueOf(),
      wvt: q(this.context.location && this.context.location.search)
    };
  }

  getEventEnvironmentArgs() {
    return {
      url: this.context.location.href,
      referrer: this.context.document.referrer,
      page_uuid: this.pageUuid
    };
  }

  processEvents() {
    if (this.loading) return;
    let e = this.eventQueue.slice(0, N);
    if (this.eventQueue = this.eventQueue.slice(N), !e.length) return;
    let n = i({
      events: e
    }, this.getRequestEnvironmentArgs());
    this.loading = !0;

    let r = () => {
      this.emitter.emit(K), this.eventQueue.length ? (this.processEventsDebounced(), this.emitter.emit(F)) : this.emitter.emit(Q), this.loading = !1;
    },
        s = () => {
      this.loading = !1;
    };

    this.sendToServer(n, r, s);
  }

  updateProcessEventsDebounced() {
    var e, n, r, s;
    this.processEventsDebounced = O(this.processEvents.bind(this), (n = (e = this.wtConfig.debounce) == null ? void 0 : e.min) != null ? n : ne, {
      maxWait: (s = (r = this.wtConfig.debounce) == null ? void 0 : r.max) != null ? s : re
    });
  }

};

function B(t) {
  return new v(t);
}

var C = B(global);
var {
  WTProvider: ae,
  useTrack: ce,
  useWT: ue
} = b(t => C.track(t)),
    de = C;